<template>
  <div class="el-tabs-container">
    <el-tabs v-model="tab_index">
      <el-tab-pane label="采购订单池">
        <span slot="label"><i class="iconfont icon-search" style="font-size: 14px"></i>&nbsp;{{
          $t("tab.tab_purch_order_pool") }}</span>
        <SplitContainer2 style="height:100%" layout="horizontal">
          <template #table1>
            <TableMain name="myName" ref="PurchaseOrderTable1" :fields="fields" :title="table_title.title1"
              :date_picker_label="date_picker_label" :query_button_label="query_lable" :show_date_picker="true"
              :show_toolbar="false" :show_filter="true" :selectable="true" :isBusy="isBusy_table1"
              :hb_table_class="'hb_table_PurchaseOrder_class1'" :table_height_adjust="-8" @on_query="on_query"
              @state_change="state_change" :show_toolbar_button="[0, 0, 0, 0, 0]" @tool_invoke="tool_invoke"
              @current_changed="current_changed" tableref="b8e681e4f2ff4ab4951e822ccda8c31f">
              <template #query>
                {{ $t("common.provider") + $t("common.num") }}：<el-input clearable size="small" style="width: 100px"
                  v-model="OrderAccount">
                </el-input>
                {{ $t("common.provider") + $t("common.name") }}：<el-input clearable size="small" style="width: 120px"
                  v-model="OrderAccountName">
                </el-input>
              </template>
            </TableMain>
          </template>
          <template #table2>
            <TableMain ref="PurchaseOrderTable2" :fields="itemfields" :show_query_container="false"
              :show_toolbar="false" :title="table_title.title2" :date_picker_label="date_picker_label"
              :table_height_adjust="8" :show_filter="false" :isBusy="isBusy_table2"
              :hb_table_class="'hb_table_PurchaseOrder_class2'" tableref="6832767f7e954e02b90700ad3995df38">
              <!-- <template #operation>
          <el-button type="success" size="mini" plain class="iconfont icon-save">&nbsp;保 存</el-button>
        </template> -->
            </TableMain>
          </template>
        </SplitContainer2>
      </el-tab-pane>
      <el-tab-pane label="明细列表">
        <span slot="label"><i class="iconfont icon-search" style="font-size: 14px"></i>&nbsp;{{ $t("tab.tab_detail")
          }}</span>
        <PurchaseOrderItems></PurchaseOrderItems>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
// import axios from "axios"
// -- import * as _ from "lodash-es"
import * as api from "@/shared/api"
import QueryButton from "../components/base/QueryButton"
import TableMain from "../components/table/TableMain"
import TableDetail from "../components/table/TableDetail"
import TestQueryPanel from "../components/base/TestQueryPanel"
import BaseContainer from "../components/BaseContainer"
import EntityEditor from "../components/base/EntityEditor"
import SplitContainer2 from "../components/container/SplitContainer2"
import { Split } from "view-design"
import "view-design/dist/styles/iview.css"
import * as PurchaseOrderController from "../../controllers/mm/PurchaseOrderController"
import PurchaseOrderItems from "./PurchaseOrderItems.vue"

export default {
  name: "PurchaseOrder",
  components: {
    QueryButton,
    TableDetail,
    TableMain,
    TestQueryPanel,
    BaseContainer,
    EntityEditor,
    Split,
    SplitContainer2,
    PurchaseOrderItems,
  },
  data() {
    return {
      tab_index: 0,
      date_picker_label: "common.search",
      query_lable: this.$t("common.query"),
      table_title: {
        title1: "table_purch_order",
        title2: "table_purch_order_detail",
      },
      fields: PurchaseOrderController.fields.default,
      itemfields: PurchaseOrderController.fields.item_fields,
      isBusy_table1: false,
      isBusy_table2: false,
      OrderAccount: "",
      OrderAccountName: "",
    }
  },
  activated() { },
  deactivated() { },
  computed: {},

  methods: {
    ///查询
    async on_query(set_data, date_range) {
      this.isBusy_table1 = true

      set_data([])
      let _fromDate = "",
        _toDate = ""
      let _params = {
        // OrderAccountName: { like: "%" + this.OrderAccountName + "%" },
        // is_deleted: { "=": 0 },
      }
      _params.OrderAccountName = this.OrderAccountName
      _params.OrderAccount = this.OrderAccount

      // if (this.OrderAccount != "") {
      //   _params.OrderAccount = { like: "%" + this.OrderAccount + "%" };
      // }
      if (
        !_.isNull(date_range) &&
        this.OrderAccount == "" &&
        this.OrderAccountName == ""
      ) {
        _fromDate = this.$date.format(date_range[0], "yyyy-MM-dd")
        _toDate = this.$date.format(date_range[1], "yyyy-MM-dd")
        _toDate = this.$date.format(
          this.$date.addDays(new Date(_toDate), 1),
          "yyyy-MM-dd"
        )
        //_params["create_at"] = { ">=": _fromDate, "<=": _toDate };
        _params.fromDate = _fromDate
        _params.toDate = _toDate
      }
      let _result = await PurchaseOrderController.methods.getData(_params)
      if (!_.isNull(_result) && _result && _result.length > 0) {
        set_data(_.orderBy(_result[0], ["id"], ["desc"]))
      }
      this.isBusy_table1 = false
    },
    state_change(data, cb) { },
    tool_invoke(data) { },
    async current_changed(old, current) {
      if (_.isNull(current)) {
        this.$refs.PurchaseOrderTable2.SetData([])
        return
      }

      this.isBusy_table2 = true

      let _result = await PurchaseOrderController.methods.getItemData({
        PurchaseOrderId: { "=": current.id },
        is_deleted: { "=": 0 },
      })
      if (!_.isNull(_result) && _result && _result.length > 0) {
        this.$refs.PurchaseOrderTable2.SetData(
          _.orderBy(_result[0], ["LineNumber"], ["asc"])
        )
      }

      this.isBusy_table2 = false
    },
  },
}
</script>
<style>
.hb_table_PurchaseOrder_class1 {
  width: 100%;
  font-size: 0.8rem;
  background-color: white;
  min-width: 70rem;
}

.hb_table_PurchaseOrder_class2 {
  width: 100%;
  font-size: 0.8rem;
  background-color: white;
  min-width: 100rem;
}
</style>

<style scoped>
.one_table>>>.hb_table_query_container_one_table {
  background-color: white;
}

.hb_table_panel_container_myName>>>.b-table-sticky-header>.table.b-table>.hb_thead>.hb_thead_tr>.b-table-sticky-column.hb_thead_th_name {
  left: 21px;
}

.hb_table_panel_container_myName>>>.b-table-sticky-header>.table.b-table>.hb_tbody>.hb_tbody_tr>.b-table-sticky-column.hb_tbody_td_name {
  left: 21px;
}
</style>
